import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_KEY } from "../config";

export const stripe = loadStripe(STRIPE_KEY);
